export default __webpack_public_path__ + "static/media/img_regua_horintal_guarana_nova.b05055e0.png";